import { useSelector } from "react-redux";
import { Banner } from "app/modules/shared/banner/Banner";
import { selectAPIUnavailable, selectAuthAPIUnavailable } from "./APIStatusSlice";

export const APIStatusBanner: React.FC = () => {
  const apiUnavailable = useSelector(selectAPIUnavailable);
  const authAPIUnavailable = useSelector(selectAuthAPIUnavailable);

  if (!authAPIUnavailable && !apiUnavailable) return <></>;

  return (
    <Banner
      data-test-id="api-status-banner__dismiss-button"
      title="Could not reach your server"
      iconClassName="fa-wifi-exclamation"
      className="px-5 mb-2 mt-4"
    >
      Please check your internet connection and{" "}
      <a data-test-id="api-status-banner__refresh-the-page-link" href="" onClick={() => location.reload()}>
        refresh the page
      </a>
    </Banner>
  );
};
